// API service for Unmapped.blr

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Unknown error' }));
    throw new Error(error.detail || 'API request failed');
  }
  return response.json();
};

// Get all site content at once
export const getAllContent = async () => {
  const response = await fetch(`${API_URL}/api/content`);
  return handleResponse(response);
};

// Hero API
export const getHero = async () => {
  const response = await fetch(`${API_URL}/api/hero`);
  return handleResponse(response);
};

// About API
export const getAbout = async () => {
  const response = await fetch(`${API_URL}/api/about`);
  return handleResponse(response);
};

export const updateAbout = async (data) => {
  const response = await fetch(`${API_URL}/api/about`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return handleResponse(response);
};

// Walks API
export const getWalks = async () => {
  const response = await fetch(`${API_URL}/api/walks`);
  return handleResponse(response);
};

export const addWalkLocation = async (location) => {
  const response = await fetch(`${API_URL}/api/walks/locations`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(location),
  });
  return handleResponse(response);
};

export const updateWalkLocation = async (id, data) => {
  const response = await fetch(`${API_URL}/api/walks/locations/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return handleResponse(response);
};

export const deleteWalkLocation = async (id) => {
  const response = await fetch(`${API_URL}/api/walks/locations/${id}`, {
    method: 'DELETE',
  });
  return handleResponse(response);
};

// Games API
export const getGames = async () => {
  const response = await fetch(`${API_URL}/api/games`);
  return handleResponse(response);
};

export const updateGames = async (data) => {
  const response = await fetch(`${API_URL}/api/games`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return handleResponse(response);
};

// Workshops API
export const getWorkshops = async () => {
  const response = await fetch(`${API_URL}/api/workshops`);
  return handleResponse(response);
};

export const addWorkshopImage = async (image) => {
  const response = await fetch(`${API_URL}/api/workshops/images`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(image),
  });
  return handleResponse(response);
};

export const updateWorkshopImage = async (id, data) => {
  const response = await fetch(`${API_URL}/api/workshops/images/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return handleResponse(response);
};

export const deleteWorkshopImage = async (id) => {
  const response = await fetch(`${API_URL}/api/workshops/images/${id}`, {
    method: 'DELETE',
  });
  return handleResponse(response);
};

// Contact API
export const getContact = async () => {
  const response = await fetch(`${API_URL}/api/contact`);
  return handleResponse(response);
};

export const updateContact = async (data) => {
  const response = await fetch(`${API_URL}/api/contact`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return handleResponse(response);
};

// Seed database
export const seedDatabase = async () => {
  const response = await fetch(`${API_URL}/api/seed`, {
    method: 'POST',
  });
  return handleResponse(response);
};
